import { render, staticRenderFns } from "./SelectX.vue?vue&type=template&id=38ecf336&scoped=true&"
import script from "./SelectX.vue?vue&type=script&lang=js&"
export * from "./SelectX.vue?vue&type=script&lang=js&"
import style0 from "./SelectX.vue?vue&type=style&index=0&id=38ecf336&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ecf336",
  null
  
)

export default component.exports